module.exports = __webpack_public_path__ + "static/media/step1.d57a8fc0.png";